import { service } from "@/api/service ";
import { toastError, toast } from "@/components/custom/Toast";
import store from "../..";

const state = {
  Rbtypes: [],
  Rbtype: {},
  pagination: {},
  addStatus: false,
  editStatus: false,
  deleteStatus: false,
};
const getters = {
  EmprbtypesListGet: (state) =>
    state.Rbtypes.map((obj) => {
      const updatedRbtypesObj = { ...obj };
      updatedRbtypesObj.rbtype.hasTax = obj.rbtype.hasTax === 0 ? "no" : "yes";
      return updatedRbtypesObj;
    }),
  RbtypesGet: (state) => state.Rbtype,
};
const actions = {
  getEmployeeRbtypes({ commit }, payload) {
    console.log(payload, "it is refetching");
    let page = payload.isModal ? 0 : store.state.page.page;
    let url = `employee-rpTypes?page=${page}`;
    if (payload?.rpType) {
      url = `employee-rpTypes?rb-type=${payload?.rpType}&page=${page}`;
    }
    console.log(url);
    service.getFun(url).then(
      (obj) => {
        var result = obj?.data?.data;
        const pageResult = {
          currentPage: obj.data.current_page,
          lastPage: obj.data.last_page,
          itemsPerPage: obj.data.per_page,
          total: obj.data.total,
        };
        commit("setPagination", pageResult);
        commit("EmpRbtypesListSet", result);
      },
      (error) => {
        console.log("Rbtypes..." + error);
        toastError(error);
      }
    );
  },

  addEmoplyeeRbtypes({ commit }, payload) {
    service
      .postFun(service.deleteNullValues(payload), `employee-rpTypes`, null, {
        action: "getEmployeeRbtypes",
        param: payload.rpType,
      })
      .then(
        (result) => {
          commit("addRbtypestatus", result.success);
          toast(result.message);
        },
        (error) => {
          console.log("courses..." + error);
          toastError(error);
        }
      );
  },
  getRbtypesById({ commit }, payload) {
    service.getFun(`Rbtypes/${payload.id}`).then(
      (obj) => {
        var result = obj.data;
        commit("getRbtypesById", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  editEmpRbtypes({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `employee-rpTypes/${payload.id}`,
        null,
        {
          action: "getEmployeeRbtypes",
          param: payload.rpType,
        }
      )
      .then(
        (result) => {
          commit("editRbtypestatus", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
  deleteEmpRbtypes({ commit }, payload) {
    console.log(payload, "payload");
    service
      .deleteFun(`employee-rpTypes/${payload?.payload}`, {
        action: "getEmployeeRbtypes",
        EMPRPTYPE: payload?.EMPRPTYPE,
      })
      .then(
        (result) => {
          commit("deleteRbtypestatus", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
};
const mutations = {
  EmpRbtypesListSet(state, Rbtypes) {
    state.Rbtypes = Rbtypes;
  },

  getRbtypesById(state, Rbtypes) {
    state.Rbtypes = Rbtypes;
  },
  addRbtypestatus(state, Status) {
    state.addStatus = Status;
  },
  editRbtypestatus(state, Status) {
    state.editStatus = Status;
  },
  deleteRbtypestatus(state, Status) {
    state.deleteStatus = Status;
  },
  setPagination(state, pageResult) {
    state.pagination = pageResult;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
